<template>
  <div id="lm-wait">

  <b-form-input
        class="my-1"
        list="my-list-id"
        v-model="options.companyName"
        @input="inputDataList"
        :value="itemsMarcasTodas.name"/>

    <b-datalist id="my-list-id">
        <option v-for="(itemsMarcasTodas, index) in itemsMarcasTodas" :key="index">
          {{ itemsMarcasTodas.name }}
        </option>
      </b-datalist>

  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'

export default {
  components: {
    LmSelect
  },
  props: {
    itemsMarcasTodas: {
      type: Array,
      default: () => []
    },
    form: {
      dataList: ''
    },
    companyName: '',
    dataValue: '',
    index: '',
    options: {
      type: Object,
      id: '',
      default: () => ({
        disabledOption: 'Seleccione una acción',
        content: []
      })
    }
  },
  methods: {
    inputDataList (event) {
      // Busco el objeto en todas las marcas por el nombre
      let i = this.itemsMarcasTodas.find(item => item.name === event)
      // Voy al array active.items[x] del objeto padre y cambio el id
      this.$parent.$parent.$parent.$parent.active.items[this.index].id = i.id
    }
  },
  mounted () {

  }
}
</script>
